import { render, staticRenderFns } from "./NovaPoshtaBtn.vue?vue&type=template&id=fca6396c"
import script from "./NovaPoshtaBtn.vue?vue&type=script&lang=js"
export * from "./NovaPoshtaBtn.vue?vue&type=script&lang=js"
import style0 from "./NovaPoshtaBtn.vue?vue&type=style&index=0&id=fca6396c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports